import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AldeiaPoloBaseDseiDto } from 'src/app/models/AldeiaPoloBaseDsei';
import { MensagemService } from 'src/app/pages/gestor/shared/services/mensagem.service';
import { GerarPdfService } from 'src/app/services/gerar-pdf.service';
import { MapeamentoIndigenaService } from 'src/app/services/mapeamento-indigena.servie';
import { RascunhoService } from 'src/app/services/rascunho.service';
import { DOCUMENT } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
    selector: 'app-modal-exportar',
    templateUrl: './modal-exportar.component.html',
    styleUrls: ['./modal-exportar.component.scss'],
})
export class ModalExportarComponent implements OnInit {

    @Input() estabelecimento: any = {};
    @Input() idRascunho;
    @Input() idEstabelecimento;

    formGroup: FormGroup;

    ignoreChecksForTabs = [
        'identificacao',
        'caracterizacao',
        'recursosFisicos',
        'recursosHumanos',
        'origem'
    ];

    checkParent = {
        identificacao: [
            'PRINCIPAL',
            'COMPLEMENTAR',
            'ENDERECO_COMPLEMENTAR'
        ],
        caracterizacao: [
            'GERAL',
            'SERVICOS',
            'MARCACOES'
        ],
        recursosFisicos: [
            'INSTALACAO',
            'LEITOS',
            'EQUIPAMENTOS'
        ],
        recursosHumanos: [
            'PROFISSIONAIS',
            'EQUIPES'
        ]
    };



    constructor(
        private modalController: ModalController,
        private formBuilder: FormBuilder,
        private mensagemService: MensagemService,
        private geracaoPdf: GerarPdfService,
        private mapeamentoservice: MapeamentoIndigenaService,
        private rascunhoService: RascunhoService,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.formGroup = this.formBuilder.group({
            origem: ['', Validators.required],
            identificacao: [false],
            caracterizacao: [false],
            recursosFisicos: [false],
            recursosHumanos: [false],
            PRINCIPAL: [false],
            COMPLEMENTAR: [false],
            'ENDERECO_COMPLEMENTAR': [false],
            GERAL: [false],
            SERVICOS: [false],
            MARCACOES: [false],
            INSTALACAO: [false],
            LEITOS: [false],
            EQUIPAMENTOS: [false],
            PROFISSIONAIS: [false],
            EQUIPES: [false],

        }, { updateOn: 'blur' })
    }

    async ngOnInit() {
        console.log(this.estabelecimento);
        if (!this.idEstabelecimento) {
            this.formGroup.get('origem').setValue('rascunho');
            this.formGroup.get('origem').updateValueAndValidity();
        }
    }

    async fechar(opcao) {
        await this.modalController.dismiss(opcao);
    }

    async gerarPdf() {
        console.log(this.estabelecimento)
        if (this.formGroup.invalid) {
            await this.mensagemService.showToast('Informe os dados corretamente');
            return;
        }
        let tabs = Object.entries(this.formGroup.value).filter(([key, value]) => {
            if (this.ignoreChecksForTabs.find((i) => i === key)) {
                return false;
            }
            return value;
        }).map(([key, _]) => key.toLocaleUpperCase());

        if (!tabs.length) {
            tabs = Object.entries(this.formGroup.value).filter(([key, _]) => {
                if (this.ignoreChecksForTabs.find((i) => i === key)) {
                    return false;
                }
                return true;
            }).map(([key, _]) => key.toLocaleUpperCase());
        }

        try {
            await this.mensagemService.presentLoading('Gerando relatório.', 'gr');
            let data;
            let indigena: any = {};
            let mapeamento: any = {};
            try {
                if (tabs.includes('COMPLEMENTAR')) {
                    if (this.formGroup.get('origem').value === 'rascunho') {
                        mapeamento = await this.mapeamentoservice.getMapeamentoByRascunho(this.estabelecimento.idRascunho) || {};
                    } else {
                        mapeamento = await this.mapeamentoservice.getMapeamentoByEstabelecimento(this.estabelecimento.idEstabelecimento) || {};
                    }
                }
            } catch (e) {
                console.log(e);
                indigena = {
                    aldeia: mapeamento.codigoAldeia ? mapeamento.codigoAldeia + ' -N/A' : 'N/A',
                    poloBase: mapeamento.codigoPoloBase ? mapeamento.codigoPoloBase + ' -N/A' : 'N/A',
                    dsei: mapeamento.codigoDsei ? mapeamento.codigoDsei + ' -N/A' : 'N/A'
                }
            }
            if (!(mapeamento || mapeamento.codigoAldeia || mapeamento.codigoPoloBase || mapeamento.codigoDsei)) {
                indigena = {
                    aldeia: mapeamento.codigoAldeia ? mapeamento.codigoAldeia + ' -N/A' : 'N/A',
                    poloBase: mapeamento.codigoPoloBase ? mapeamento.codigoPoloBase + ' -N/A' : 'N/A',
                    dsei: mapeamento.codigoDsei ? mapeamento.codigoDsei + ' -N/A' : 'N/A'
                }
            } else {
                if (mapeamento.codigoAldeia) {
                    try {

                        const raw: any = await this.mapeamentoservice.getAldeiaPoPoloBaseDseiPorCodAldeia(mapeamento.codigoAldeia);
                        if (raw && raw.record) {
                            indigena.aldeia = raw.record.codigoAldeia + " - " + raw.record.nomeAldeia;
                            indigena.poloBase = raw.record.codigoPoloBase + " - " + raw.record.nomePoloBase;
                            indigena.dsei = raw.record.codigoDsei + " - " + raw.record.nomeDsei;
                        }
                    } catch {
                        indigena = {
                            aldeia: mapeamento.codigoAldeia ? mapeamento.codigoAldeia + ' -N/A' : 'N/A',
                            poloBase: mapeamento.codigoPoloBase ? mapeamento.codigoPoloBase + ' -N/A' : 'N/A',
                            dsei: mapeamento.codigoDsei ? mapeamento.codigoDsei + ' -N/A' : 'N/A'
                        }
                    }
                } else {
                    try {

                        if (mapeamento.codigoPoloBase) {
                            const raw: any = await this.mapeamentoservice.getPoloBaseById(mapeamento.codigoPoloBase);
                            if (raw && raw.record) {
                                indigena.poloBase = raw.record.codigo + " - " + raw.record.nome;
                            }
                        }
                    } catch {
                        indigena = {
                            poloBase: mapeamento.codigoPoloBase ? mapeamento.codigoPoloBase + ' -N/A' : 'N/A',
                        }
                    }
                    if (mapeamento.codigoDsei) {
                        try {

                            const raw: any = await this.mapeamentoservice.getDseiById(mapeamento.codigoDsei);
                            if (raw && raw.record) {
                                indigena.dsei = raw.record.codigo + " - " + raw.record.nome;
                            }
                        } catch {
                            indigena = {
                            dsei: mapeamento.dsei ? mapeamento.dsei + ' -N/A' : 'N/A',
                        }
                        }
                    }
                }
            }
            const dto = {
                ...indigena,
                abas: tabs,
            }
            if (this.formGroup.get('origem').value === 'rascunho') {
                data = await this.geracaoPdf.getRelatorioRascunho(this.estabelecimento.idRascunho, dto);
            } else {
                data = await this.geracaoPdf.getRelatorioEstabelecimento(this.estabelecimento.idEstabelecimento, dto);
            }
            if (data) {
                const pdfBlob = new Blob([data], {
                    type: 'application/pdf'
                });
                const downloadLink = this.document.createElement('a');
                const url = window.URL.createObjectURL(pdfBlob);
                downloadLink.href = url;
                downloadLink.download = `Ficha do ${this.formGroup.get('origem').value} CNES ${this.estabelecimento.cnes || ' - '} ${this.estabelecimento.nomeFantasiaRascunho} - ${this.formGroup.get('origem').value}.pdf`;
                this.document.body.appendChild(downloadLink);
                downloadLink.click();
            }
        } catch (e) {
            console.log(e);
            await this.mensagemService.showToast('Erro ao gerar relatório.');
        } finally {
            await this.mensagemService.dismissSpecificLoading('gr');
        }

    }

    checkUncheckChildren(value, parent: string) {
        if (!this.checkParent[parent]) {
            return;
        }
        this.checkParent[parent].forEach((child) => {
            this.formGroup.get(child).setValue(value.detail.checked);
            this.formGroup.get(child).updateValueAndValidity();
        });
    }

    uncheckParent(event, parent) {
        if (!event.detail.checked) {
            this.formGroup.get(parent).setValue(false);
            this.formGroup.get(parent).updateValueAndValidity();
        }

    }


}
